import api, { adminApiPrefix } from './Api';
import {
  ShipmentImage,
  shipmentImageFromResponse,
} from '../interfaces/ShipmentImage/ShipmentImage';
import { PartnerPlatform } from '../interfaces/PartnerPlatform/PartnerPlatform';

const shipmentImageApiPrefix = `${adminApiPrefix}/shipment-images`;

export const uploadShipmentImage = async (
  platform: PartnerPlatform,
  orderID: number,
  image: File,
): Promise<void> => {
  const formData = new FormData();
  formData.append('image', image);

  return api.post(`${shipmentImageApiPrefix}/${platform}/${orderID}`, formData);
};

export const getShipmentImages = async (
  platform: PartnerPlatform,
  orderID: number,
): Promise<ShipmentImage[]> => {
  const response = await api.get(
    `${shipmentImageApiPrefix}/${platform}/${orderID}`,
  );

  return (response.data?.data ?? []).map(shipmentImageFromResponse);
};

export const deleteShipmentImage = async (id: number): Promise<void> =>
  api.delete(`${shipmentImageApiPrefix}/${id}`);

export const deletePlatformShipmentImageAtIndex = async (
  platform: PartnerPlatform,
  orderID: number,
  index: number,
): Promise<void> =>
  api.delete(
    `${shipmentImageApiPrefix}/platform/${platform}/${orderID}/${index}`,
  );
